import { G as GITHUB_API_KEY } from "../../chunks/private.js";
import * as cheerio from "cheerio";
import admin from "firebase-admin";
const getLatestTag = () => {
  const url = "https://api.github.com/repos/carlelieser/glimmr-release/tags";
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${GITHUB_API_KEY}`
    }
  }).then((response) => response.json()).then((tags) => {
    const latest = tags[0];
    if (!latest) return null;
    return latest;
  }).catch(() => {
    return null;
  });
};
const getInstallerMetadata = async (tag) => {
  const response = await fetch(
    `https://github.com/carlelieser/glimmr-release/releases/expanded_assets/${tag}`
  );
  const html = await response.text();
  const $ = cheerio.load(html);
  const link = $(`a[href*='/carlelieser/glimmr-release/releases/download/${tag}/']`);
  const size = link.parent().parent().children().last().children().first().text().trim();
  return {
    url: `/releases/${tag}/glimmr-setup.exe`,
    name: "glimmr-setup.exe",
    tag,
    size
  };
};
const getUserCount = async (count, pageToken) => {
  const result = await admin.auth().listUsers(1e3, pageToken);
  count += result.users.length;
  if (result.pageToken !== void 0) {
    count = await getUserCount(count, result.pageToken);
  }
  return count;
};
const getTrustPilotInfo = async () => {
  const response = await fetch("https://www.trustpilot.com/review/glimmr.app");
  const html = await response.text();
  const $ = cheerio.load(html);
  const data = $("div[data-rating-component='true']").first();
  const bannerImageUrl = data.find("img").attr("src");
  const rating = data.find("*[data-rating-typography='true']").text();
  const logoImageUrl = $("a[name='company-logo']").children().first().attr("src");
  return { logoImageUrl, bannerImageUrl, rating };
};
const getPrices = async (_fetch) => {
  const response = await _fetch("/api/prices");
  return response.json();
};
const load = async ({ fetch: fetch2 }) => {
  const tag = await getLatestTag();
  const [metadata, userCount, trustPilotInfo, prices] = await Promise.all([
    getInstallerMetadata(tag.name),
    getUserCount(0),
    getTrustPilotInfo(),
    getPrices(fetch2)
  ]);
  return {
    metadata,
    userCount,
    trustPilotInfo,
    prices
  };
};
export {
  load
};
